import axiosInstance from '../config/axios';

export interface CodeVaultAccessRecord {
  user_id: string;
  read_access: boolean;
  write_access: boolean;
  delete_access: boolean;
  is_approver?: boolean;
  is_reviewer?: boolean;
}

export interface CodeVaultAccessResponse {
  data: CodeVaultAccessRecord[];
  approver?: boolean;
  reviewer?: boolean;
}

async function getUserAccess(userId: string): Promise<CodeVaultAccessRecord | null> {
  const response = await axiosInstance.get<CodeVaultAccessResponse>(`/codevault/code-vault-access/${encodeURIComponent(userId)}`);
  const record = response.data?.data?.[0] || null;
  
  if (record) {
    record.is_approver = response.data.approver || false;
    record.is_reviewer = response.data.reviewer || false;
  }
  
  return record;
}

export const codeVaultService = {
  getUserAccess,
};

export default codeVaultService;
